import one from '../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.png'
import four from '../assets/svg/projects/four.png'
import five from '../assets/svg/projects/five.png'
import six from '../assets/svg/projects/six.png'
import seven from '../assets/svg/projects/seven.png'
import eight from '../assets/svg/projects/eight.png'
import nine from '../assets/svg/projects/nine.png'
import ten from '../assets/svg/projects/ten.png'
import eleven from '../assets/svg/projects/eleven.png'
import twelve from '../assets/svg/projects/twelve.png'
import kfc from "../Images/KFC.gif"


export const projectsData = [
    {
        id: 13,
        projectName: '“KFC.com” Clone',
        projectDesc: 'A cloned application of KFC.com which is a Fast Food restaurant chain ( Collaborative Project)',
        tags: [ "React "," Redux "," React Slick ","  Mongo Atlas "," Express "," Mongoose "," Bootstrap "," Postman "," Context API "," Styled Components "," FontAwesome","RazorPay"],
        code: 'https://github.com/mdarshadkhan1998/KFC-clone-full-stack',
        demo: 'https://clone-kfc.netlify.app/',
        image: kfc
    },
    {
        id: 14,
        projectName: 'Fraazo Clone',
        projectDesc: 'Fraazo is an e-commerce website that sells a variety of healthy food products.',
        tags: ['React', 'Redux','BootStrap', 'Chakra UI',"Semantic UI", "Styled Components", "Mongo Atlas", "Mongoose", "Express JS", "Node JS", "Nodemailer", "JWT", "bcrypt JS"],
        code: 'https://github.com/mdarshadkhan1998/fraazo-clone',
        demo: 'https://fraazo-website-clone.netlify.app/',
        image: "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fstatic.businessworld.in%2Farticle%2Farticle_extra_large_image%2F1591704478_WBcETY_Fraazo.jpg&f=1&nofb=1"
    },
    {
        id: 1,
        projectName: 'Clone of BOBBI BROWN COSMETICS',
        projectDesc: 'This collaborative project aimed to build a Clone of an E-Commerce website for beauty Products.',
        tags: ['React', 'Redux', 'JavaScript', 'ParseHub ', 'BootStrap', 'Tailwind', 'Material UI'],
        code: 'https://github.com/mdarshadkhan1998/Bobbi-Brown-Cosmetics',
        demo: 'https://bobbi-brown-clone-arshad-abhinav-yogesh-shivanshu-rahul-nikesh.netlify.app/',
        image: "https://github.com/mdarshadkhan1998/Bobbi-Brown-Cosmetics/raw/main/bobbi-brown/src/Readme%20Images/Gif.gif"
    },
    {
        id: 16,
        projectName: 'Resizer Chrome Extention',
        projectDesc: 'This collaborative project aimed to build a Clone of an E-Commerce website for beauty Products.',
        tags: ['React', 'Redux', 'JavaScript', 'ParseHub ', 'BootStrap', 'Tailwind', 'Material UI'],
        code: "https://github.com/AFFAN-AHMAD/hackathon",
        demo: 'https://drive.google.com/file/d/1wPvMe1CS1qFVuTauHpWS8-Cu9IlDMdqq/view',
        image: "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fgifimage.net%2Fwp-content%2Fuploads%2F2017%2F08%2Fresize-gif-online-3.gif&f=1&nofb=1"
    },
    {
        id: 15,
        projectName: 'Clockify.me Clone',
        projectDesc: 'Clockify is a time tracker and timesheet app that lets you track work hours across projects.',
        tags: ['JavaScript', 'HTML', 'CSS', 'React', 'Redux','BootStrap', "Material UI", "Styled Components", "Mongo Atlas", "Mongoose", "Express JS", "Node JS", "JWT", "bcrypt JS"],
        code: 'https://github.com/PratikMate/handy-string-7765',
        demo: 'https://clockify-clone-by-arshad-pratik-rakesh.netlify.app/',
        image: "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fstore.suitecrm.com%2Fassets%2Fimg%2Faddonassets%2Ftimekeeping%2FSalesPage%2FTimeTracking.gif&f=1&nofb=1"
    },
    {
        id: 2,
        projectName: '“blink-It” Clone',
        projectDesc: 'This collaborative project aimed to build a clone of an leading E-Commerce website for all kind of grocery products such as fruits, vegetables and many more with an instant delivery system.',
        tags: ['JavaScript', 'HTML', 'CSS', 'ParseHub', 'GitHub', 'BootStrap'],
        code: 'https://github.com/gauravkrs/blinkit',
        demo: 'https://blink-it-by-arshad-gaurav-ayush-rohit-shubham.netlify.app/',
        image: "https://miro.medium.com/max/875/1*J2lxr_tAx_YxoGNO2CTwhg.gif"
    },
    {
        id: 3,
        projectName: 'Clone of ebay.in',
        projectDesc: 'It is a support platform that helps sellers to sell their variety of products globally.',
        tags: ['JavaScript', 'HTML', 'CSS'],
        code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        demo: 'https://ebay-clone-by-arshad-khan.netlify.app/',
        image: three
    },
    {
        id: 4,
        projectName: 'Youtube Clone',
        projectDesc: 'This individual project consist of search (anything) and full Screen video play functionality.',
        tags: ['JavaScript', 'HTML', 'CSS'],
        code: 'https://youtube-basic-functionalities-by-arshad-khan.netlify.app/',
        demo: 'https://youtube-basic-functionalities-by-arshad-khan.netlify.app/',
        image: four
        // image:"https://github.com/mdarshadkhan1998/Project-Gifs/blob/main/images/Untitled%20design.gif"
    },
    {
        id: 5,
        projectName: 'All Indian Dishes Recipe App',
        projectDesc: 'An individual project that uses an API to fetch all Indian Dishes Recipe',
        tags: ['JavaScript', 'HTML3', 'CSS'],
        code: 'https://food-app-by-arshad-khan.netlify.app/',
        demo: 'https://food-app-by-arshad-khan.netlify.app/',
        image: five
    },
    {
        id: 6,
        projectName: 'Ordering Food Counter for Restaurant',
        projectDesc: 'This individual project elucidates about an Restaurant Order Placing System, by showing us a demo of random delaying in each process using debouncing.',
        tags: ['JavaScript', 'HTML3', 'CSS'],
        code: 'https://order-creating-by-arshad-khan.netlify.app/',
        demo: 'https://order-creating-by-arshad-khan.netlify.app/',
        image: six
    },
    {
        id: 7,
        projectName: '7 Days Weather Forecast App',
        projectDesc: 'This individual project gives us 7 days weather forecast for searched location',
        tags: ['JavaScript', 'HTML3', 'CSS'],
        code: 'https://weather-report-by-arshad-khan.netlify.app/',
        demo: 'https://weather-report-by-arshad-khan.netlify.app/',
        image: seven
    },
    {
        id: 8,
        projectName: 'Global Movie Search App',
        projectDesc: 'This app helps user to search for any movie Globally and look for its details',
        tags: ['JavaScript', 'HTML3', 'CSS'],
        code: 'https://debouncing-scroll-movie-search-by-arshad-khan.netlify.app/',
        demo: 'https://debouncing-scroll-movie-search-by-arshad-khan.netlify.app/',
        image: eight
    },
    {
        id: 11,
        projectName: 'Restaurant Items Generating',
        projectDesc: 'Here we can add items in the Restaurant List, And more of it we can filter it by price and rating. For this we need to run db.json on localhost:3000/',
        tags: ['JavaScript', 'HTML3', 'CSS'],
        code: 'https://github.com/masai-course/arshad_fw16_018/tree/master/unit-4/src/sprint-2/day-3/assignments/Restaurant',
        demo: 'https://restaurant-item-list-adding-and-sorting-by-arshad-khan.netlify.app/',
        image: twelve
    },
    {
        id: 9,
        projectName: 'OMDB Movie App',
        projectDesc: 'This Page consist of Login/SignUp Functionality along with popular movies data',
        tags: ['JavaScript', 'HTML3', 'CSS'],
        code: 'https://slider-by-arshad-khan.netlify.app/',
        demo: 'https://slider-by-arshad-khan.netlify.app/',
        image: nine
    },
    {
        id: 10,
        projectName: 'Github Clone',
        projectDesc: 'This app helps user to search for any GitHub Username and fetch all his repositories.',
        tags: ['JavaScript', 'HTML3', 'CSS'],
        code: 'https://github-by-arshad-khan.netlify.app/',
        demo: 'https://github-by-arshad-khan.netlify.app/',
        image: ten
    },
    {
        id: 12,
        projectName: 'E-Commerce for Men, Women and Kids',
        projectDesc: 'An E-Commerce for Men, Women and Kids with some toggling and sorting which can only be accessable after a successful login',
        tags: ['JavaScript', 'HTML3', 'CSS'],
        code: 'https://fanciful-beignet-ae045f.netlify.app/',
        demo: 'https://fanciful-beignet-ae045f.netlify.app/',
        image: eleven
    },
]
